export type CampaignDocumentModel = {
  cache_key: number,
  campaign_id: number,
  document_type: string,
  file: string,
  file_file_name: string,
  id: number,
  title: string,
}

export type CampaignDocumentRequestOptions = {}

const state = {
  id: null,
  campaign_id: undefined,
  document_type: '',
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
